export const TASK_STATUSES = ['черновик', 'в работе', 'закрыта', 'архив'] as const;

export type TaskLifecycleStatus = (typeof TASK_STATUSES)[number];

export const TASK_STATUS_FILTER_OPTIONS: TaskLifecycleStatus[] = [...TASK_STATUSES];

export function normalizeTaskStatus(
  status: TaskLifecycleStatus | string | undefined | null,
): TaskLifecycleStatus {
  const raw = status?.trim().toLowerCase();
  if (raw === 'архив' || raw === 'archive') return 'архив';
  if (raw === 'закрыта' || raw === 'закрыт') return 'закрыта';
  if (raw === 'черновик') return 'черновик';
  if (raw === 'в работе' || raw === 'active' || raw === 'активная') return 'в работе';
  return 'в работе';
}

export function getTaskStatusLabel(status: TaskLifecycleStatus | string | undefined | null): string {
  return normalizeTaskStatus(status);
}

export function isTaskInWork(status: TaskLifecycleStatus | string | undefined | null): boolean {
  return normalizeTaskStatus(status) === 'в работе';
}

export function isTaskArchived(status: TaskLifecycleStatus | string | undefined | null): boolean {
  return normalizeTaskStatus(status) === 'архив';
}

export function taskStatusBadgeVariant(
  status: TaskLifecycleStatus | string | undefined | null,
): 'active' | 'archive' | 'contract' {
  const normalized = normalizeTaskStatus(status);
  if (normalized === 'в работе') return 'active';
  if (normalized === 'архив') return 'archive';
  return 'contract';
}
